import { z } from 'zod';
import {
  validateClubOperatingHourSlot,
  type ClubOperatingHourSlot,
} from '../utils/clubOperatingHours';

const operatingHourSlotSchema = z.object({
  dayOfWeek: z.number().int().min(0).max(6),
  startTime: z.string().min(1),
  endTime: z.string().min(1),
});

export const locationFormSchema = z.object({
  name: z.string().min(1, 'Location name is required').max(255, 'Name too long'),
  address: z.string().max(2000).optional().or(z.literal('')),
  googleMapsPlaceId: z.string().max(255).optional().or(z.literal('')),
  googleMapsAddress: z.string().max(500).optional().or(z.literal('')),
  isActive: z.boolean().default(true),
  sortOrder: z.number().int().min(0).default(0),
  operatingHoursOverride: z
    .array(operatingHourSlotSchema)
    .nullable()
    .optional()
    .superRefine((slots, ctx) => {
      if (!slots) return;
      for (let i = 0; i < slots.length; i++) {
        const slot = slots[i] as ClubOperatingHourSlot;
        const error = validateClubOperatingHourSlot(slot);
        if (error) {
          ctx.addIssue({ code: z.ZodIssueCode.custom, message: error, path: [i] });
        }
      }
    }),
});

export type LocationFormData = z.infer<typeof locationFormSchema>;
